import React from "react";
import { useI18n } from "../../i18n";
import { formatAmount } from "../utils/money";

const StepButton = ({ label, onClick, children }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={label}
    className="w-10 h-10 rounded-xl bg-slate-800 border border-slate-700 text-white text-xl font-bold leading-none flex items-center justify-center hover:bg-slate-700 active:scale-95 transition-all"
  >
    {children}
  </button>
);

/** One ticket line with thumb sized quantity controls. */
const TicketLine = ({ line, currency, onIncrement, onDecrement, onRemove }) => {
  const { t } = useI18n();
  const { product, quantity } = line;
  const oversell = quantity > product.stock_quantity;

  return (
    <div className="flex items-center gap-3 px-4 py-3 border-b border-slate-800 last:border-0">
      <div className="min-w-0 flex-1">
        {/* Two lines, not one: the part that tells flavours of a range apart is
            at the end of a long name, which a single line cuts off */}
        <p className="text-sm font-semibold text-white leading-tight line-clamp-2">
          {product.name}
        </p>
        <p className="text-xs text-slate-400 tabular-nums mt-0.5">
          {quantity} × {formatAmount(product.unit_price)} {currency}
          {oversell && (
            <span className="ms-2 text-amber-400 font-semibold">
              {t("pos.ticket.notInStock")}
            </span>
          )}
        </p>
      </div>

      <div className="flex items-center gap-2">
        <StepButton
          label={t("pos.ticket.removeOne", { name: product.name })}
          onClick={onDecrement}
        >
          −
        </StepButton>
        <span className="w-7 text-center text-base font-bold text-white tabular-nums">
          {quantity}
        </span>
        <StepButton
          label={t("pos.ticket.addOne", { name: product.name })}
          onClick={onIncrement}
        >
          +
        </StepButton>
      </div>

      <div className="w-20 text-end">
        <p className="text-sm font-bold text-emerald-400 tabular-nums">
          {formatAmount(product.unit_price * quantity)}
        </p>
        <button
          type="button"
          onClick={onRemove}
          className="text-[11px] text-slate-500 hover:text-red-400 transition-colors"
        >
          {t("pos.ticket.remove")}
        </button>
      </div>
    </div>
  );
};

export default TicketLine;
